import { PlacePreferenceNonNull } from 'infra/type.ts'

export const PREFERENCE_WANT_IMAGE = require('./preference-want.png')
export const PREFERENCE_LIKED_IMAGE = require('./preference-liked.png')
export const PREFERENCE_AVOID_IMAGE = require('./preference-avoid.png')

export const DISABLED_PREFERENCE_WANT_IMAGE = require('./preference-want-disabled.png')
export const DISABLED_PREFERENCE_LIKED_IMAGE = require('./preference-liked-disabled.png')
export const DISABLED_PREFERENCE_AVOID_IMAGE = require('./preference-avoid-disabled.png')

const PREFERENCE_IMAGE_MAP = {
  WANT: [PREFERENCE_WANT_IMAGE, DISABLED_PREFERENCE_WANT_IMAGE],
  LIKED: [PREFERENCE_LIKED_IMAGE, DISABLED_PREFERENCE_LIKED_IMAGE],
  AVOID: [PREFERENCE_AVOID_IMAGE, DISABLED_PREFERENCE_AVOID_IMAGE],
}

export const getPreferenceImage = (
  preference: PlacePreferenceNonNull,
  isDisabled: boolean,
) => {
  return PREFERENCE_IMAGE_MAP[preference][!isDisabled ? 0 : 1]
}
